export default "__VITE_ASSET__CMQf$Nqe__"